import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

const columnStyles = {
  name: { width: '40px !important' },
  email: { width: '40px !important' },
  actions: { width: '40px !important', textAlign: 'center' },
};

const ApproversTable = ({ approvers, onEdit, onDelete }) => {
  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerStyle: () => columnStyles.name,
      style: columnStyles.name,
      formatter: (cell) => cell || 'N/A',
    },
    {
      dataField: 'email',
      text: 'Email',
      sort: true,
      headerStyle: () => columnStyles.email,
      style: columnStyles.email,
      formatter: (cell) => cell || 'N/A',
    },
    {
      dataField: 'actions',
      text: 'Actions',
      headerStyle: () => columnStyles.actions,
      style: columnStyles.actions,
      formatter: (cell, row) => (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
          <IconButton onClick={() => onEdit(row)} title="Edit" size="small">
            <FeatherIcon icon="edit" size={18} />
          </IconButton>
          <IconButton onClick={() => onDelete(row)} title="Delete" size="small">
            <FeatherIcon icon="trash-2" size={18} color="red" />
          </IconButton>
        </Box>
      ),
    },
  ];

  const paginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const NoDataIndication = () => (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="45vh" width="100%">
      <Box textAlign="center" py={4}>
        <FeatherIcon icon="inbox" size={40} style={{ opacity: 0.5, marginBottom: '16px' }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          There are no approvers to display
        </Typography>
      </Box>
    </Box>
  );

  const tableStyles = {
    minHeight: '50vh',
    maxHeight: '70vh',
    overflow: 'auto',
    borderRadius: 1,
    boxShadow: 1,
    position: 'relative',
    zIndex: 1,
    '& .react-bootstrap-table': {
      minHeight: '45vh'
    },
    '& table': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      tableLayout: 'fixed',
      width: '100%'
    },
    '& thead th': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#f8f9fa',
      zIndex: 2,
      borderBottom: '2px solid #dee2e6',
      padding: '12px 8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& tbody td': {
      padding: '10px 8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& tbody tr:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
    '& .pagination': {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '16px',
      borderTop: '1px solid #dee2e6',
    }
  };

  return (
    <Paper sx={{
      ...tableStyles,
      '& thead th:nth-of-type(1)': {
        width: '200px !important',
      },
      '& thead th:nth-of-type(2)': {
        width: '200px !important',
      },
      '& thead th:nth-of-type(3)': {
        width: '120px !important',
      },
    }} className="miui-table scrollable-table">
      <BootstrapTable
        keyField="_id"
        data={approvers || []}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        bootstrap4
        bordered={false}
        hover
        noDataIndication={NoDataIndication}
        wrapperClasses="table-responsive"
      />
    </Paper>
  );
};

export { ApproversTable };